module.exports = __webpack_public_path__ + "img/largueur.5717dedf.png";